import { Controller } from "@hotwired/stimulus";
import { moEmbedParentUrl } from "./embed";

// The embed's LG picker links navigate to the switch action, which redirects to the target location
// group's shell. Salespath's parent page URL lives on the shell <body> (data-mo-parent-url), not in
// the panel frame these links render in — its fetch URL carries no parent_url param — so the server
// can't put it in the hrefs. Append it here once per link, so Mo's page context survives switching
// location groups. Rewriting on connect (rather than on click) also keeps middle-click and
// ctrl-click navigations correct.
export default class extends Controller {
  static targets = ["link"];

  linkTargetConnected(link) {
    const parentUrl = moEmbedParentUrl();
    if (!parentUrl) {
      return;
    }

    const url = new URL(link.href, window.location.origin);
    url.searchParams.set("parent_url", parentUrl);
    link.href = url.toString();
  }
}
